
import {defineComponent} from 'vue';
import settingsQuery from '~/graphql/queries/settings.gql';

export default defineComponent({
  apollo: {
    settings: {
      query: settingsQuery,
    },
  },
  props: {
    confirmLabel: {
      default: 'Oké',
      required: false,
      type: String,
    },
    text: {
      required: true,
      type: String,
    },
    title: {
      default: 'Delen',
      required: false,
      type: String,
    },
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      settings: undefined,
      currentUrl: '',
    };
  },
  mounted() {
    this.currentUrl = location.origin + this.$nuxt.$route.path;
  },
});
